module.exports = __webpack_public_path__ + "static/BentonSansExtraComp-Regular-63c0976dbb036a2b3705d852121862b2.woff";